module.exports = __webpack_public_path__ + "static/media/license_a.7785dd3e.png";